export default __webpack_public_path__ + "static/media/Kings.c2a9a9db.png";